$(function(){
  setupLoadingNumbers();
})

/*
cachovat offset objektu do pole (DICTIONARY <offset, obj>)
na scroll check vysky -> pokud vyssi -> load number, odebrat
na resize obrazovky prepocitat vysky
*/

function setupLoadingNumbers() {
  loadNumbers();
  $(window).scroll(function(){
    loadNumbers();
  });
}

function loadNumbers(){
  $('.load-from-zero').each(function(i,obj){ 
    if($(this).isOnScreen()){
      $(this).toggleClass('load-from-zero');
      var $el = $(this),
          value = $(this).data('maximum');
      $({counter: 0}).stop(true).animate({counter: value}, {
          duration : 3000,
          easing: 'swing',
          step: function () {
              $el.text(formatText(Math.round(this.counter).toString()) + ($el.data('post') ? $el.data('post') : ''));
          }
      }).promise().done(function () {
          $el.text(formatText(value.toString()) + ($el.data('post') ? $el.data('post') : ''));
      });
    }
  });
}

function formatText(text){
  if(text.length <= 3) return text;
  for(i = text.length - 3; i >= 0; i-=3){
    text = text.substr(0, i) + ' ' + text.substr(i);
  }
  return text;
}

//checks if an element is visible on screen
jQuery.fn.isOnScreen = function(){
  var win = $(window);
  var viewport = {
    top : win.scrollTop(),
    left : win.scrollLeft()
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();
  var elemtHeight = this.height()/2;
  elemtHeight = Math.round(elemtHeight);
  var bounds = this.offset();
  bounds.top = bounds.top + elemtHeight;
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();
  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
}